import axios from 'axios';

// Use window.AMS_CONFIG for production compatibility
const BACKEND_API_URL = window.AMS_CONFIG?.API_URL || 'http://localhost:8000';
const API_PATH = window.AMS_CONFIG?.API_PATH || '/api';  
const API_BASE_URL = `${BACKEND_API_URL}${API_PATH}`;

const getAuditLogs = async (filters = {}) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found');
    }
    
    const params = new URLSearchParams();
    
    // Add filters to query parameters if provided
    if (filters.user_id) params.append('user_id', filters.user_id);
    if (filters.agency_id) params.append('agency_id', filters.agency_id);
    if (filters.action_type) params.append('action_type', filters.action_type);
    if (filters.entity_type) params.append('entity_type', filters.entity_type);
    if (filters.entity_id) params.append('entity_id', filters.entity_id);
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.search) params.append('search', filters.search);
    if (filters.page) params.append('page', filters.page);
    if (filters.pageSize) params.append('page_size', filters.pageSize);
    
    console.log('Fetching audit logs with filters:', Object.fromEntries(params));
    
    const response = await axios.get(`${API_BASE_URL}/audit-logs/?${params.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Audit logs response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching audit logs:', error);
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    } else if (error.request) {
      console.error('Request made but no response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};

export { getAuditLogs };
